import { defineComponent as m, ref as u, onMounted as v, watchPostEffect as b, watch as g } from "vue";
import { MsClose as h } from "@sunrise/icons";
import { pageUtils as c, clickAnywhereHandler as s } from "@sunrise/shared";
const w = m({
  name: "MsModal",
  components: {
    MsClose: h
  },
  props: {
    visible: {
      type: Boolean,
      default: !1
    },
    labelledBy: String,
    describedBy: String,
    width: String,
    height: String
  },
  emits: ["update:visible"],
  setup(e, { emit: f }) {
    const l = u(null), t = u(null);
    let a;
    v(() => {
      e.visible && o(), b(() => {
        e != null && e.visible ? d() : r();
      });
    });
    function d() {
      l.value && (t.value = document.activeElement, l.value.focus());
    }
    function r() {
      var i;
      document.activeElement instanceof HTMLElement && document.activeElement.blur(), t.value && ((i = t.value) == null || i.focus(), t.value = null);
    }
    function o() {
      c.disablePageScroll(), setTimeout(() => {
        l.value && (a = s.subscribe(l.value, n));
      });
    }
    function n() {
      c.enablePageScroll(), f("update:visible", !1), s.unsubscribe(a);
    }
    return g(
      () => e.visible,
      (i) => {
        i ? o() : n();
      }
    ), {
      dialogRef: l,
      closeModal: n
    };
  }
});
export {
  w as default
};
